module.exports = __webpack_public_path__ + "img/frzs.a63d2d02.jpg";